import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { type BusinessInsightSubsection, CardError, CardSkeleton, OnboardingBusinessInsight, Subsection, useOnboardingBusinessInsights } from '@/components/entity-onboarding-details';
import useEntityId from '@/entity/hooks/use-entity-id';
type BusinessInsightProps = {
  onboarding: EntityOnboarding;
  subsection: BusinessInsightSubsection;
};

/** One shared business insight subsection, with the loading and error states the strip layout shows once per tab. */
const BusinessInsight = t0 => {
  const $ = _c(5);
  const {
    onboarding,
    subsection
  } = t0;
  const entityId = useEntityId();
  const {
    data,
    error
  } = useOnboardingBusinessInsights(entityId, onboarding.id);
  if (!data) {
    let t1;
    if ($[0] !== error) {
      t1 = <Subsection>{error ? <CardError error={error} /> : <CardSkeleton rows={3} />}</Subsection>;
      $[0] = error;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onboarding || $[3] !== subsection) {
    t1 = <Subsection><OnboardingBusinessInsight selectedSubsection={subsection} onboarding={onboarding} /></Subsection>;
    $[2] = onboarding;
    $[3] = subsection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default BusinessInsight;